"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RULES_TOPIC = exports.SCHEDULED_CHANGES_APPLE_CHANNEL_TOPIC = exports.SYNC_APPLE_CHANNEL_TOPIC = exports.INGRESS_BID_TOPIC = exports.EGRESS_TOPIC = exports.INVOICE_PAYMENT_TOPIC = exports.ALLOCATE_BUDGET_TOPIC = exports.SEND_NOTIFICATION_MESSAGE_TOPIC = exports.SUBMIT_ORGANIC_REPLICA_UPDATE_TOPIC = exports.SUBMIT_REPLICA_UPDATE_TOPIC = exports.SUBMIT_ATTRIBUTION_TOPIC = exports.RECORD_ERROR_TOPIC = exports.RECORD_HISTORY_TOPIC = void 0;
exports.RECORD_HISTORY_TOPIC = "recordHistoryTopic";
exports.RECORD_ERROR_TOPIC = "recordErrorTopic";
exports.SUBMIT_ATTRIBUTION_TOPIC = "submitAttributionTopic";
exports.SUBMIT_REPLICA_UPDATE_TOPIC = "submitAppleReplicaUpdateTopic";
exports.SUBMIT_ORGANIC_REPLICA_UPDATE_TOPIC = "submitOrganicReplicaUpdateTopic";
exports.SEND_NOTIFICATION_MESSAGE_TOPIC = "sendNotificationMessageTopic";
exports.ALLOCATE_BUDGET_TOPIC = "allocateBudgetTopic";
exports.INVOICE_PAYMENT_TOPIC = "invoicePaymentTopic";
exports.EGRESS_TOPIC = "egressCampaignTopic";
exports.INGRESS_BID_TOPIC = "ingressBidTopic";
exports.SYNC_APPLE_CHANNEL_TOPIC = "syncAppleChannelTopic";
exports.SCHEDULED_CHANGES_APPLE_CHANNEL_TOPIC = "scheduledChangesAppleChannelTopic";
exports.RULES_TOPIC = "rulesTopic";
